import OutflowGrid from "@/components/OutflowGrid";

export default function OtherReceipts() {
  return (
    <OtherReceiptsGrid />
  );
}

// Same underlying grid — semantics differ (this contributes to inflows,
// not outflows), but the CRUD UX is identical.
function OtherReceiptsGrid() {
  return (
    <OutflowGrid
      page="other_receipts"
      testId="other-receipts"
      kicker="Overview"
      title="Other Receipts"
      editRole="any"
      description="Non-sales inflows: rental income, FDR interest, connector fees, client refund adjustments, and misc receipts. Editable by every user. Contributes to Cashflow Overview inflows KPI. Amounts in ₹ Lakhs."
    />
  );
}
